import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Lakshadeepam from "./Lakshadeepam";
import GalleryView from "./GalleryView";
import VideoGallery from "./VideoGallery";

const galleryItems = [
  // Images
  { type: "image", url: "https://spst.in/images/pic4.jpeg", category: "latest" },
  { type: "image", url: "https://spst.in/images/pic5.jpeg", category: "latest" },
  { type: "image", url: "https://spst.in/images/pic6.jpeg", category: "latest" },

  { type: "image", url: "https://spst.in/images/pic6.jpg", category: "vedic" },
  { type: "image", url: "https://spst.in/images/pic7.jpg", category: "vedic" },

  { type: "image", url: "https://spst.in/images/pic8.jpg", category: "lakshadeepam" },
  { type: "image", url: "https://spst.in/images/pic9.jpg", category: "lakshadeepam" },
  { type: "image", url: "https://spst.in/images/pic10.jpg", category: "lakshadeepam" },

  // // Videos (add your own URLs)
  // { type: "video", url: "https://www.w3schools.com/html/mov_bbb.mp4", category: "latest" },
  // { type: "video", url: "https://www.w3schools.com/html/movie.mp4", category: "vedic" },
  // { type: "video", url: "https://www.w3schools.com/html/mov_bbb.mp4", category: "lakshadeepam" },
];

function PhotoGallery() {
  const [filter, setFilter] = useState("all");

  const filteredItems =
    filter === "all"
      ? galleryItems
      : galleryItems.filter((item) => item.category === filter);

  return (
    <div>
      <div
        className="row banner"
        style={{
          backgroundImage: "url(./images/event.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      <div className="container" style={{ marginTop: "100px", marginBottom: "100px" }}>
        <VideoGallery />
        <GalleryView />
      </div>

      {/* <div className="container" style={{ marginTop: "100px", marginBottom: "100px" }}>
        <div style={{ marginBottom: "20px" }}>
          <button className="btn btn-secondary" onClick={() => setFilter("all")} style={{ marginRight: "5px" }}>All</button>
          <button className="btn btn-secondary" onClick={() => setFilter("latest")} style={{ marginRight: "5px" }}>Latest</button>
          <button className="btn btn-secondary" onClick={() => setFilter("vedic")} style={{ marginRight: "5px" }}>Vedic Seminar</button>
          <Link className="btn btn-secondary" to="../Lakshadeepam">Lakshadeepam 2019-2020</Link>
        </div>
        <div style={galleryStyle}>
          {filteredItems.map((item, index) => (
            <div key={index} style={itemStyle}>
              {item.type === "image" ? (
                <img src={item.url} alt={item.category} style={imgStyle} />
              ) : (
                <video src={item.url} controls style={videoStyle}></video>
              )}
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
}

const galleryStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  gap: "15px",
};

const itemStyle = {
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
};

const imgStyle = {
  width: "100%",
  height: "auto",
  cursor: "pointer",
};

const videoStyle = {
  width: "100%",
  height: "auto",
};

export default PhotoGallery;
